import { ReactComponent as AmexIcon } from "../assets/amex.svg";
import { ReactComponent as MastercardIcon } from "../assets/mastercard.svg";
import { ReactComponent as VisaIcon } from "../assets/visa.svg";

export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// Taken from: https://emailregex.com/

export const USERS_COLLECTION_NAME = "users";
export const PLATFORMS_COLLECTION_NAME = "platforms";
export const GROUP_COLLECTION_NAME = "groups";
export const GROUP_CREDENTIALS_COLLECTION_NAME = "groups_credentials";
export const GROUP_SUBSCRIPTION_COLLECTION_NAME = "groups_subscriptions";

export const ERROR_TOAST_DURATION = 3000;
export const SUCCESS_TOAST_DURATION = 2000;

export const PROFILE_IMAGE_FOLDER = "website";

// Spanish numbers are only 9 digits long!
export const PHONE_NUMBER_REGEX = /^\+34[1-9][0-9]{8}/;
export const SPOTIFY_LINK_REGEX = /^https:\/\/www.spotify.com\/[\w,/]+/;

// Is this the right place?
export const shadowBoxProps = {
  boxShadow: "0px 40px 50px -25px #DEE8F3",
  background: "#F5FAFF",
  borderRadius: ["30px", "30px", "30px", "60px"],
  padding: 5,
};

export const NETLFIX_PID = "netflix";
export const SPOTIFY_PID = "spotify";
export const MOVISTAR_LITE_PID = "movistar_lite";
export const FAQ_LINK = "https://preguntas.pulpo.es/";
// export const TERMS_AND_CONDITIONS_LINK =
//   "https://www.notion.so/pulpoclub/T-rminos-y-condiciones-Pulpo-9411232dc79149f99db50b46b02ab43b";
export const PRIVACY_POLICY_LINK =
  "https://www.notion.so/pulpoclub/Pol-tica-de-Privacidad-Pulpo-352b06a4a1e04fb5bf755752f37b9243";
export const JOBS =
  "https://jobs.pulpo.es";

export const HEADER_HEIGHT = "90px";
export const PEEK_IN_PIXELS = "50px";
export const CUSTOMER_SERVICE_MOBILE = "+34 640 761 414";
export const SUPPORT_WA_LINK = `https://api.whatsapp.com/send?phone=${CUSTOMER_SERVICE_MOBILE}`;

export const CARD_IMAGES = {
  visa: VisaIcon,
  mastercard: MastercardIcon,
  amex: AmexIcon,
};

export const SUGGEST_NEW_PAYOUT_TYPEFORM = "https://pulp0.typeform.com/to/Xo3GagVF";
export const SUGGEST_NEW_PLATFORM_TYPEFORM = "https://pulp0.typeform.com/to/OoOmPInK";
export const REFERRAL_SEARCH_PARAM = "referrer";
export const REFERRAL_CODE_EXPIRY_MS = 1000 * 60 * 60 * 24 * 365 // 1 year